import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chatterCo/bottomTitle.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f6dbd3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chatterCoServices" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chatterCoServices__bottomTitle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "bottomTitle__image"
  })
], -1))
const _hoisted_3 = { class: "chatterCoServices__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServicesFlipCard = _resolveComponent("ServicesFlipCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyServices, (service) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "list__item",
          key: service.name
        }, [
          _createVNode(_component_ServicesFlipCard, { thisService: service }, null, 8, ["thisService"])
        ]))
      }), 128))
    ])
  ]))
}